if (!customElements.get('tsl-in3-banner')) {
  customElements.define('tsl-in3-banner', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.productSection || this.onVariantChange) return;
      this.onVariantChange = (event) => {
        if (String(event.detail?.sectionId) !== this.dataset.productSection) return;
        const variant = event.detail?.variant;
        this.hidden = !variant?.available || variant.price < 5000 || variant.price > 500000;
      };
      document.addEventListener('product:variant-change', this.onVariantChange);
    }
    disconnectedCallback() {
      if (!this.onVariantChange) return;
      document.removeEventListener('product:variant-change', this.onVariantChange);
      this.onVariantChange = null;
    }
  });
}
